import React, { useMemo, useState } from 'react'
import styles from './BestSchoolForm.module.css'

import { Col, Container, Row } from 'react-bootstrap'
import { Button, FormSelect } from 'shards-react'
import { ORG_TYPES } from '../../../../constants/const'

const BestSchoolForm = ({ onSubmit, formData, setFormData }) => {
  const [isError, setError] = useState(false)

  const START_YEAR = 2009
  const currentYear = new Date().getFullYear() + 1

  let years = useMemo(() => {
    let yearsArray = []
    for (let i = START_YEAR; i <= currentYear; i++) {
      yearsArray.push(i + '-05-31')
    }
    return yearsArray
  }, [START_YEAR, currentYear])

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const checkSubmit = () => {
    if (formData.date) {
      setError(false)
      onSubmit()
    } else {
      setError(true)
    }
  }

  return (
    <Container fluid>
      <Row className={'mt-3'}>
        <Col md={'auto'}>
          <FormSelect onChange={onChange} name='date' value={formData.date}>
            <option value='' selected disabled>
              Выберите дату отчета
            </option>
            {[...years].reverse().map(item => (
              <option value={item}>{item.split('-').reverse().join('.')}</option>
            ))}
          </FormSelect>
        </Col>
        <Col md={'auto'}>
          <FormSelect onChange={onChange} name='school' value={formData.school}>
            {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
          </FormSelect>
        </Col>
        <Col md={'auto'}>
          <Button onClick={checkSubmit}>Составить</Button>
        </Col>
      </Row>

      {isError && <div className={styles.error}>Укажите дату отчета</div>}
    </Container>
  )
}

export default BestSchoolForm
